export default "__VITE_ASSET__fe0af11b__"